import { useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Form, Input, DatePicker, Select, Button, Card } from "antd";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Option } = Select;

export default function AddAppraisal() {
    const { authData, backUrl } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        try {
            setLoading(true);

            // Format the date fields to YYYY-MM-DD for backend
            const formattedValues = {
                ...values,
                eligibility_date: values.eligibility_date
                    ? values.eligibility_date.format("YYYY-MM-DD")
                    : null,
                employee_due_date: values.employee_due_date
                    ? values.employee_due_date.format("YYYY-MM-DD")
                    : null,
            };

            const res = await axios.post(
                `${backUrl}/api/appraisal/appraisal-cycles/`,
                formattedValues,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            toast.success("Appraisal added successfully!", {
                position: "top-right",
                autoClose: 3000,
            });

            form.resetFields();
        } catch (error) {
            console.error("Error adding appraisal:", error);
            toast.error(
                error.response?.data?.message || "Failed to add appraisal. Please try again.",
                {
                    position: "top-right",
                    autoClose: 4000,
                }
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <Card
                title="Add New Appraisal"
                bordered={false}
                style={{
                    maxWidth: 600,
                    margin: "40px auto",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    borderRadius: "12px",
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{
                        status: "Active",
                    }}
                >
                    {/* Appraisal Name */}
                    <Form.Item
                        label="Appraisal Name"
                        name="name"
                        rules={[{ required: true, message: "Please enter the appraisal name" }]}
                    >
                        <Input placeholder="Enter appraisal name" />
                    </Form.Item>

                    {/* Status */}
                    <Form.Item
                        label="Status"
                        name="status"
                        rules={[{ required: true, message: "Please select a status" }]}
                    >
                        <Select placeholder="Select status">
                            <Option value="Active">Active</Option>
                            {/* <Option value="Draft">Draft</Option> */}
                        </Select>
                    </Form.Item>

                    {/* Eligibility Date */}
                    <Form.Item
                        label="Eligibility Date"
                        name="eligibility_date"
                        rules={[{ required: true, message: "Please select eligibility date" }]}
                    >
                        <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: "100%" }}
                            placeholder="Select eligibility date"
                        />
                    </Form.Item>

                    {/* Employee Due Date */}
                    <Form.Item
                        label="Employee Due Date"
                        name="employee_due_date"
                        rules={[{ required: true, message: "Please select employee due date" }]}
                    >
                        <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: "100%" }}
                            placeholder="Select employee due date"
                        />
                    </Form.Item>

                    {/* Submit Button */}
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            style={{
                                backgroundColor: "#0e497b",
                                borderColor: "#0e497b",
                                borderRadius: "6px",
                            }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "#1060a0")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "#0e497b")
                            }
                        >
                            Submit Appraisal
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </>
    );
}
